import { GrupoService } from './../../../_core/services/grupo.service';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CadastroBem } from 'src/app/_core/models/cadastro-bem';
import { Page } from 'src/app/_core/models/page';
import { PageService } from 'src/app/_core/services/page.service';

@Component({
  selector: 'app-cautela-grupos',
  templateUrl: './cautela-grupos.component.html',
  styleUrls: ['./cautela-grupos.component.scss']
})
export class CautelaGruposComponent implements OnInit {
  pagina = 1;
  total = 10;
  page: Page;
  ativo = true;
  pesquisa = '';
  loading = true;
  cadastro: CadastroBem;
  constructor(
    private pageService:PageService,
    private modalService:NgbModal,
    private grupoService:GrupoService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(){
    this.ativo = true;
    this.page = new Page();
    this.page.currentPage = this.pagina;
    this.page.pageSize = this.total;
    this.page.ativo = this.ativo;
    this.page.currentPage = 1;
    this.setPage(this.page.currentPage);
  }

  refresh() {
    this.document.location.reload();
  }
  setPage(page:number){
    this.loading = true;
    this.page.currentPage = page;
    this.grupoService.listarBensPage(this.page)
    .subscribe(
      data => {
        this.page = data;
        this.page = this.pageService.getPager(this.page);
        this.loading = false;
        
      },
      err => {
        this.loading = false;
      })
  }
  paginaAtual(pagina:any) {
    return this.page.currentPage === pagina;
  }
  pesquisar() {
    this.page.pesquisa = this.pesquisa;
    this.page.ativo = this.ativo;
    this.page.dados = [];
    this.setPage(1);
  }
  atualizar() {
    this.pesquisa = '';
    this.ativo = true;
    this.page.dados = [];
    this.pesquisar();
  }
}
